<template>
  <h3 class="line-label" :data-label="labelText"></h3>
</template>

<script>
export default {
  props: {
    labelText: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.line-label {
  font-size: 12px;
  font-weight: bold;
  color: #666;
  text-transform: uppercase;
  padding: 0 10px;
  margin: 0 0 6px 0;
  height: 14px;
  line-height: 14px;
  width: 100%;
  position: relative;

  &:before {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: #ddd;
    left: 0;
    top: 50%;
    position: absolute;
  }

  &:after {
    content: attr(data-label);
    display: block;
    position: absolute;
    background-color: #fff;
    padding: 0 4px;
    top: 0;
  }
}
</style>
